(function () {
  function initSection(section) {
    var tabs = section.querySelectorAll('[data-mc-tab]');
    var panels = section.querySelectorAll('[data-mc-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-mc-tab');

        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');

        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-mc-panel') === target);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mc-cat-home]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
